import Logo from 'assets/images/coachbetter_Logo_Black.webp'
import BackgroundImage from 'assets/images/signup-background.jpeg'

export const DEFAULT_CLUB_ID = 1

export const DEFAULT_CLUB_THEME = {
  logo: Logo,
  backgroundimage: BackgroundImage,
  subtitle: 'Welcome coach, your digital assistant is ready to support you!',
  signupsubtitle:
    'We empower soccer coaches to unleash the full potential of their team at any level.',
  theme: 'DEFAULT',
  backgroundcolor: '#FFF',
  primarycolor: '#3ea371',
  secondarycolor: '#255f64',
  textcolor: '#000000',
  buttoncolor: '#ffffff',
  redcolor: '#f44336',
}
